import moment from 'moment';
import isBankHoliday from './isBankHoliday';
import isJonesMarketHoliday from './isJonesMarketHoliday';

/* See isLastSellingDayREADME for more details on calculation */
const getDaysInMonth = (month, year) => {
  const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const leapYearDaysInMonth = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (year % 4 === 0) {
    if (year % 100 === 0 && year % 400 !== 0) {
      return daysInMonth[month];
    }
    return leapYearDaysInMonth[month];
  }
  return daysInMonth[month];
};
const getLastSellingDay = (month, year, countryCode) => {
  const lastDateOfMonth = getDaysInMonth(month, year);
  const calendarMonth = month + 1;
  let lastSellingDay = moment(`${lastDateOfMonth}-${calendarMonth}-${year}`, 'DD-MM-YYYY');
  if (countryCode === 'en-us') {
    /* In US, Last Selling Day is two business days prior to the last Friday of the month, except in
    December when the last selling day is two business days prior to the last day of the month.
    businessDays = days between last selling day and settlement day, now T + 2 */
    let businessDays = 2;
    // If December
    if (month === 11) {
      // Keep moving back in week until businessDay is 0 to find last selling day
      while (businessDays > 0) {
        if (lastSellingDay.day() === 0 || lastSellingDay.day() === 6 || isBankHoliday(lastSellingDay) || isJonesMarketHoliday(lastSellingDay, countryCode)) {
          // If lastSellingDay is Sunday or Saturday or Holiday, don't count as business day
          lastSellingDay = lastSellingDay.subtract(1, 'day');
        } else {
          lastSellingDay = lastSellingDay.subtract(1, 'day');
          businessDays -= 1;
        }
      }
      // If lastSellingDay is Sunday, go back 2 days to Friday
      if (lastSellingDay.day() === 0) {
        lastSellingDay = lastSellingDay.subtract(2, 'days');
      }
      // If lastSellingDay is Sunday, go back 1 day to Friday
      // (tested every year through 9999 and this code never runs)
      /* istanbul ignore next */
      if (lastSellingDay.day() === 6) {
        lastSellingDay = lastSellingDay.subtract(1, 'day');
      }
      return {
        month: lastSellingDay.month(),
        date: lastSellingDay.date(),
        year: lastSellingDay.year()
      };
    }
    // If not December, keep moving back in the month until you reach a Friday
    while (lastSellingDay.day() !== 5) {
      lastSellingDay = lastSellingDay.subtract(1, 'day');
    }
    // If not December, move back in the week from Friday
    // Once businessDays is 0, that will be last selling day
    while (businessDays > 0) {
      if (isBankHoliday(lastSellingDay) || isJonesMarketHoliday(lastSellingDay, countryCode)) {
        // Don't count holiday as business day
        lastSellingDay = lastSellingDay.subtract(1, 'day');
      } else {
        lastSellingDay = lastSellingDay.subtract(1, 'day');
        businessDays -= 1;
      }
    }
    return {
      month: lastSellingDay.month(),
      date: lastSellingDay.date(),
      year: lastSellingDay.year()
    };
  }
  // If locale is CA rather than US, the last selling day is the final business day of the month */
  while (lastSellingDay.day() === 0 || lastSellingDay.day() === 6 || isBankHoliday(lastSellingDay) || isJonesMarketHoliday(lastSellingDay, countryCode)) {
    lastSellingDay = lastSellingDay.subtract(1, 'day');
  }
  return {
    month: lastSellingDay.month(),
    date: lastSellingDay.date(),
    year: lastSellingDay.year()
  };
};
const isLastSellingDay = (day, countryCode) => {
  if (!day) {
    return false;
  }
  const month = day.month();
  const date = day.date();
  const year = day.year();
  const lastSellingDay = getLastSellingDay(month, year, countryCode);
  return month === lastSellingDay.month && date === lastSellingDay.date && year === lastSellingDay.year;
};
export default isLastSellingDay;
//# sourceMappingURL=isLastSellingDay.js.map